import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useCounterStore = create(
  persist(
    (set) => ({
      // State variables
      premiumForm: false, // Indicates if the premium form is active
      sidePromptModal: true, // Indicates if the side prompt modal is visible
      sidePromptModalClicked: false, // Tracks if the side prompt modal has been clicked
      _hasHydrated: false, // Internal flag for hydration status
      sourceId: "", // Source ID state variable

      // Actions to update state variables
      setPremiumForm: (value) => set({ premiumForm: value }), // Updates premiumForm state
      setSidePromptModal: (value) => set({ sidePromptModal: value }), // Updates sidePromptModal state
      setSidePromptModalClicked: (value) =>
        set({ sidePromptModalClicked: value }), // Updates sidePromptModalClicked state
      setHasHydrated: (state) => set({ _hasHydrated: state }), // Updates hydration status
      setSourceId: (id) => set({ sourceId: id }), // Action to set sourceId
    }),
    {
      name: "counter-store", // Name for the persisted store

      // variables to persist
      partialize: (state) => ({
        _hasHydrated: state._hasHydrated,
        sidePromptModalClicked: state.sidePromptModalClicked,
        sidePromptModal: state.sidePromptModal,
      }),

      // Actions to run after hydration
      onRehydrateStorage: () => (state) => {
        if (state) state.setHasHydrated(true);
      },
    }
  )
);
